
import axios from 'axios'
// import store from '@/store'
// import router from '@/router'

// 接口请求过期时间设置
axios.defaults.timeout = 50000
// 设置 baseURL
axios.defaults.baseURL = process.env.VUE_APP_File_API

// axios.interceptors.request.use(
//   config => {
//     // 登录状态时 接口里批量加入 请求头
//     // let token =
//     // if (token) {
//     //   config.headers.Authorization = `Bearer ${token}`
//     // }
//     return config
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )

// // http response interceptors
// axios.interceptors.response.use(
//   response => {
//     return response
//   },
//   error => {
//     if (error.response) {
//       switch (error.response.status) {
//         case 401:
//           // 状态码返回时 统一处理异常状态  比如 加提示语 退出登录等操作
//           break
//         case 490:
//           break
//       }
//     }
//     return Promise.reject(error.response.data)
//   }
// )

// 使用Promise封装请求接口
const http = {
  get (url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        params,
        url
      }).then(res => {
        resolve(res)
      })
    })
  },
  post (url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        data,
        url
      }).then(res => {
        resolve(res)
      })
    })
  },
  put (url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        data,
        url
      }).then(res => {
        resolve(res)
      })
    })
  },

  patch (url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'patch',
        data,
        url
      }).then(res => {
        resolve(res)
      })
    })
  },
  delete (url) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url
      }).then(res => {
        resolve(res)
      })
    })
  }
}
export default http
